import { Theme } from '@mui/material/styles'

const muiInput = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        '&:hover': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main
          }
        },
        '&.Mui-disabled': {
          color: theme.colors.placeholder,
          background: theme.colors.subHover
        }
      },
      input: {
        fontSize: '0.875rem',
        borderRadius: 10,
        '&.Mui-disabled': {
          cursor: 'not-allowed'
        },
        '&::-webkit-input-placeholder': {
          color: theme.colors.caption,
          opacity: 1
        },
        '&::-moz-placeholder': {
          color: theme.colors.caption,
          opacity: 1
        },
        '&:-moz-placeholder': {
          color: theme.colors.caption,
          opacity: 1
        },
        '&&:-ms-input-placeholder': {
          color: theme.colors.caption,
          opacity: 1
        },
        '&:placeholder': {
          color: theme.colors.disabled,
          opacity: 1
        }
      }
    }
  }
}

export default muiInput
